module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _vm._v("THE BALLAD OF THE CHOSEN"), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("(as sung by the soldiers of Winterhome)")])]), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_vm._v("When day turned dark and shadows fell")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Across the broken lands")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And madness turned to taloned claws Our ancient ruler’s hands")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then eight were called by whims of fate")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To save us from our doom;")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Chosen came to guard us all")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And lay evil in its tomb")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-param"
  }, [_c('em', [_vm._v("[chorus]")]), _vm._v(" If a Wizard Lord should turn"), _c('br'), _vm._v("Against the common man"), _c('br'), _vm._v("These Chosen eight would bring him down,"), _c('br'), _vm._v("Bring peace to Barokan!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Leader shows his bold resolve")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Confronting every foe")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His words would guide the Chosen as")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He told them how to go")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Seer sought the comrades out")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And gathered them to fight")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nor could their foeman hide from her;")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She has the second sight")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("[chorus]")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Swordsman’s blade is swift and sure")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His skill is unsurpassed")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("If any stood against him, then")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That stand would be his last")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A lovely face the Beauty has,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And shapely legs and arms")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She distracted evil men")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And lured them with her charms")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("[chorus]")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is no lock nor guarded door")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That can stop the Thief")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He penetrates the fortress dark")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To bring the land relief")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Every song and story told,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Scholar knows them all")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He knew the wizard’s weaknesses")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To hasten evil’s fall")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("[chorus]")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Archer’s missiles never miss;")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His arrows find their mark")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He struck at evil from afar")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To drive away the dark")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Speaker harks to every tongue,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of stone and beast and man")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She found the Dark Lord’s secrets out")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So no defense could stand")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("[chorus]")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When in the Galbek Hills there was")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A monster come in human shape")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The Swordsman struck the evil down")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To save the land from magic rape")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And thus the last of evil’s spawn")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Was driven out of Barokan")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Never more will madness come")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To trouble Barokan")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No new Wizard Lord will turn")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Against the common man")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These Chosen eight shall keep him wise,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bring peace to Barokan—")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yes, the Chosen guard us all,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bring peace to Barokan!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61884eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 87
// module chunks = 0